<template>
  <div class="container">
    <el-card shadow="hover" class="tree-box">
      <el-collapse v-model="activeName" class="collapse">
        <el-collapse-item
          :title="item.groupName"
          :name="index"
          v-for="(item,index) in dataList"
          :key="index"
        >
          <div
            class="children"
            v-for="(info,idx) in item.child"
            :key="idx"
            @click="node_click(info)"
          >{{info.tableName}}</div>
        </el-collapse-item>
      </el-collapse>
    </el-card>
    <div class="right-box">
        <div class="activeLabel">{{activeLabel}}</div>
        <!-- <msFormPreview :model="filedList"></msFormPreview> -->
      </div>
  </div>
</template>

<script>
import ToolBar from "@/components/ToolBar.vue";
import HelpHint from "@/components/HelpHint.vue";
export default {
  data() {
    return {
      dataList: [
        { groupName: "治疗问卷表", child: [{ tableName: "咨询表" }] },
        {
          groupName: "骨科治疗问卷表",
          child: [
            { tableName: "颈椎" },
            { tableName: "胸椎" },
            { tableName: "肋关节" },
            { tableName: "腰椎" },
            { tableName: "尾椎关节" },
            { tableName: "耻骨联合与骶髂关节" },
            { tableName: "肩带关节" },
            { tableName: "肩关节" },
            { tableName: "肩带部分" },
            { tableName: "肘关节" },
            { tableName: "前臂关节" },
            { tableName: "腕关节" },
            { tableName: "掌骨关节" },
            { tableName: "掌指关节" },
            { tableName: "手指指间关节" },
            { tableName: "髋关节" },
            { tableName: "膝关节" },
            { tableName: "小腿" },
            { tableName: "踝关节" },
            { tableName: "距下关节" },
            { tableName: "跗跖关节与跖骨间关节" },
            { tableName: "脚趾间关节" },
            { tableName: "下颚关节" },
            { tableName: "盆骨关节之特殊检查" }
          ]
        },
        {
          groupName: "诊疗表",
          child: [
            { tableName: "中医师诊疗咨询" },
            { tableName: "骨伤医师体格关节检查表" },
            { tableName: "病程记录表" },
            { tableName: "体能测试" },
            { tableName: "教练员课程分析" }
          ]
        }
      ],
      activeName: 0,
      filedList: [],
      activeItem: "",
      activeLabel: ""
    };
  },
  mounted() {
    // this.getUser();
  },
  methods: {
    //获取用户详情
    getUser() {
      var that = this;
      that.$axios
        .get(that.baseUrl + "/queryWxUser", {
          params: {
            userId: that.userId
          }
        })
        .then(res => {
          that.userData = res.data;
        })
        .catch(error => {
          console.log(error);
        });
    }
  },
  components: {
    ToolBar,
    HelpHint
  }
};
</script>
<style scoped>
.container {
  width: 100%;
  height: 100%;
  overflow-y: auto;
  display: flex;
  flex-direction: row;
}
.tree-box {
  width: 200px;
  min-width: 165px;
  margin-right: 20px;
  overflow-y: auto;
}
.right-box {
  width: 100%;
}
.tree-box /deep/ .el-card__body {
  padding: 0;
}
.collapse {
  padding: 0 20px;
}
.children {
  padding-left: 20px;
  line-height: 26px;
  cursor: pointer;
}
.children:hover {
  color: #2d64a8;
}
.activeLabel {
  font-size: 18px;
  color: #2d64a8;
  margin-bottom: 10px;
}
.tree-box /deep/ .el-collapse-item__header {
  line-height: 20px;
  height: auto;
  padding: 16px 0;
}
.tree-box /deep/ .el-collapse-item__arrow {
  line-height: 20px;
}
</style>
